<template>
    <v-navigation-drawer
      v-model="Vue.$store.state.config.drawler"
      temporary
      fixed
      v-if="Vue.$store.state.config.language === 'ro'"
    >
      <v-list class="pa-1">
        <v-list-tile>
          <v-list-tile-title class="title">
            {{$t('navbar.menu')}}
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
      <v-list class="pt-0" dense>
        <v-divider></v-divider>
        <v-list-tile to="/">
          <v-list-tile-action>
            <v-icon>fas fa-calendar-alt</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ $t('navbar.predict') }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile to="/clasament">
          <v-list-tile-action>
            <v-icon>fas fa-list-ul</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ $t('navbar.list') }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile to="/premii">
          <v-list-tile-action>
            <v-icon>fas fa-trophy</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ $t('navbar.gifts') }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile to="/reguli">
          <v-list-tile-action>
            <v-icon>fas fa-gift</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ $t('navbar.rules') }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
  <v-navigation-drawer
    v-model="Vue.$store.state.config.drawler"
    temporary
    fixed
    v-else
  >
    <v-list class="pa-1">
      <v-list-tile>
        <v-list-tile-title class="title">
          {{$t('navbar.menu')}}
        </v-list-tile-title>
      </v-list-tile>
    </v-list>
    <v-list class="pt-0" dense>
      <v-divider></v-divider>
      <v-list-tile to="/ru" exact>
        <v-list-tile-action>
          <v-icon>fas fa-calendar-alt</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ $t('navbar.predict') }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile to="/ru/turnirnaja-tablica">
        <v-list-tile-action>
          <v-icon>fas fa-list-ul</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ $t('navbar.list') }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile to="/ru/prizy">
        <v-list-tile-action>
          <v-icon>fas fa-trophy</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ $t('navbar.gifts') }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile to="/ru/uslovija">
        <v-list-tile-action>
          <v-icon>fas fa-gift</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ $t('navbar.rules') }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'drawler',
  data () {
    return {
      Vue: this
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/partials/drawler.vue